import {Hero} from "../../components/HomePageComponents/Hero/Hero";
import {Products} from "../../components/HomePageComponents/Products/Products";
import {About} from "../../components/HomePageComponents/About/About";
import {WhyUs} from "../../components/HomePageComponents/WhyUs/WhyUs";
import {Basement} from "../../components/CummonComponents/Basement/Basement";
import {Map} from "../../components/CummonComponents/Map/Map";
import {useHome, useImageUrl} from "../../queries";
import {Loading} from "../../components/CommonComponents/Loading/Loading";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";

export const Home = () => {
    const {data, isLoading} = useHome();

    return (
        <>
            <Helmet>
                <title>Homepage | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Hero data={data}/>
                    <Products data={data}/>
                    <About data={data}/>
                    <WhyUs data={data}/>
                    <Basement back={true} data={data}/>
                    {data?.about_us && <Map data={data.about_us}/>}
                </>
            )}
        </>
    )
}
